<fieldset [formGroup]="optionGroup" *ngIf="visible$ | async">
    <ng-container *ngrxLet="optionFunctionalElement$; let optionFunctionalElement">
        <div class="row">
            <p class="col" [innerHTML]="optionFunctionalElement.label"></p>
        </div>
        <pace-forms-choices
            [choices]="choices$ | async"
            *ngIf="optionFunctionalElement.choices"
            [formControl]="radioInputControl"
        ></pace-forms-choices>
    </ng-container>
</fieldset>
